import React from "react";
import PdfLayout from '../PdfLayout';
import PdfLayoutWidget from './PdfLayoutWidget';
import { Screen } from '../../services';
import i18n from '../../locales/i18n';

import imagePlaceholder from '../../assets/images/imagePlaceholder.webp';

/**
 * Image widget filled from a resolved CMS / blog post at render time.
 */
class PostImageWidget extends PdfLayoutWidget {

    constructor(properties) {
        super({
            ...(PostImageWidget.getDefaultOptions()),
            ...properties,
            type: PdfLayout.IMAGE,
            subType: PdfLayout.POST_IMAGE,
        });
    }

    static getDefaultOptions() {
        return {
            position: { x: 2, y: 2, z: 0 },
            dimensions: { width: 6, height: 4 },
            transform: { rotation: 0 },
            options: {
                mode: 'latest',
                category_id: '',
                post_id: '',
                post_key: 'default',
                style: {
                    align: 'center',
                    objectFit: 'cover',
                    borderStyle: 'solid',
                    borderWidth: 0,
                    borderColor: '#000000',
                    borderRadius: 0,
                    padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                    },
                },
            },
        };
    }

    getHandledOptions() {
        return super.getHandledOptions().concat([
            PdfLayout.OPTION_POST_SELECTION,
            PdfLayout.OPTION_OBJECT_FIT,
            PdfLayout.OPTION_ALIGNMENT,
            PdfLayout.OPTION_PADDING,
        ]);
    }

    getPreview(props) {
        const { inEdition } = props;
        const imageStyle = {
            width: '100%',
            height: '100%',
            objectFit: this.options?.style?.objectFit || 'cover',
        };

        return (
            <div style={{
                textAlign: this.options?.style?.align,
                width: Screen.cmToPx(this.dimensions?.width),
                height: Screen.cmToPx(this.dimensions?.height),
                backgroundColor: this.options?.style?.backgroundColor,
                border: `${this.options?.style?.borderWidth || 0}px ${this.options?.style?.borderStyle || 'solid'} ${this.options?.style?.borderColor || '#000'}`,
                borderRadius: `${this.options?.style?.borderRadius || 0}px`,
                paddingTop: `${Screen.cmToPx(this.options?.style?.padding?.top || 0)}px`,
                paddingRight: `${Screen.cmToPx(this.options?.style?.padding?.right || 0)}px`,
                paddingBottom: `${Screen.cmToPx(this.options?.style?.padding?.bottom || 0)}px`,
                paddingLeft: `${Screen.cmToPx(this.options?.style?.padding?.left || 0)}px`,
                overflow: 'hidden',
                position: 'relative',
            }}>
                <img
                    src={imagePlaceholder}
                    alt={i18n.t('layouts.alt_post_image')}
                    style={{
                        ...imageStyle,
                        width: Screen.cmToPx(this.dimensions?.width) - (inEdition ? 2 : 0),
                        height: Screen.cmToPx(this.dimensions?.height) - (inEdition ? 2 : 0),
                    }}
                />
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                }} />
            </div>
        );
    }

    getIcon() {
        return 'picture-o';
    }
}

export default PostImageWidget;
